import { Injectable } from '@angular/core';

@Injectable()
export class GetuserService {
  private _username: string = '';
  private _isConfirmSignup: boolean = false;
  private _model:{};
  private _cityName: string= '';
  private _stateName: string = '';
  private  _countryName: string = '';
  private  fromForgetPassword: boolean = false;
  constructor() { }

  get username(): string {
    return this._username;
  }

  set username(value: string) {
    this._username = value;
  }

  get isConfirmSignup(): boolean {
    return this._isConfirmSignup;
  }

  set isConfirmSignup(value: boolean) {
    this._isConfirmSignup = value;
  }

  get isForgetScreen(): boolean {
    return this.fromForgetPassword;
  }

  set isForgetScreen(value: boolean) {
    this.fromForgetPassword = value;
  }

  get model(): {} {
    return this._model;
  }

  set model(value: {}) {
    this._model = value;
  }
  get cityName(): string {
    return this._cityName;
  }

  set cityName(value: string) {
    this._cityName = value;
  }
  get stateName(): string {
    return this._stateName;
  }

  set stateName(value: string) {
    this._stateName = value;
  }
  get countryName(): string {
    return this._countryName;
  }

  set countryName(value: string) {
    this._countryName = value;
  }

  reset(){
     this._username = '';
     this._isConfirmSignup = false;
     this._model = {};
     this._cityName= '';
     this._stateName= '';
      this._countryName= '';
      this.fromForgetPassword = false;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/_services/getuser.service.ts